import { pathJoin } from 'src/reducers/routing/utils'

export const createContainerCreateRouteMap = (prefix: string) => ({
  configuration: pathJoin(prefix)('configuration').chain,
  routes: pathJoin(prefix)('route').chain,
  'service-log': pathJoin(prefix)('service-log').chain,
  'inquiry-log': pathJoin(prefix)('inquiry-log').chain,
})
